const api = require('./api-caller')

module.exports = {
  getDataProducts: () => {
    const endpoint = '/exchange/'
    return api(endpoint, 'GET')
  }
}
